export const TIME_MESSAGE: string =
	'Informe um tempo entre 00:00:00 até 100000:59:59.';

export const PRODUCT_FILTER_MESSAGE: string =
	'Utilize o filtro a direita para selecionar produtos com ou sem roteiro.';

export const REQUIRED_FIELD_MESSAGE: string = 'Campo obrigatório.';
